import { ActivitySubjects } from "@outschool/business-rules";
import { useTranslation } from "@outschool/localization";
import { Container } from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React, { useRef } from "react";

import HeroSection from "./HeroSection";
import useTutoringPageQuery from "./hooks/useTutoringPageQuery";
import NavBar from "./NavBar";
import PopularTutoringSubjects from "./PopularTutoringSubjects";
import PopularTutors from "./PopularTutors";
import TutoringByGrade from "./TutoringByGrade";
import TutoringByTopics from "./TutoringByTopics";
import TutoringCategoryListing from "./TutoringCategoryListing";
import TutoringForEveryAge from "./TutoringForEveryAge";
import TutoringRecommendedArticles from "./TutoringRecommendedArticles";
import TutoringReviews from "./TutoringReviews";
import TutoringValues from "./TutoringValues";
import WhyTutoringOnOutschool from "./WhyTutoringOnOutschool";

function TutoringPageBody() {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\TutoringPageBody"
  );
  const whyTutoringRef = useRef<HTMLElement | null>(null);
  const { articles, visualLinkGridsCollectionItems, popularSubjects } =
    useTutoringPageQuery();
  const isMobile = useIsMobile();

  return (
    <>
      <NavBar />
      <HeroSection />
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: `${isMobile ? "7rem" : "10rem"}`
        }}
      >
        <TutoringValues scrollToRef={whyTutoringRef} />
        {!!popularSubjects?.length && (
          <PopularTutoringSubjects subjects={popularSubjects} />
        )}

        <TutoringCategoryListing
          /* eslint-disable-next-line i18next/no-literal-string */
          subject={ActivitySubjects.ActivitySubject.English}
          categoryTitle={t("English Reading & Writing")}
        />
        <TutoringCategoryListing
          /* eslint-disable-next-line i18next/no-literal-string */
          subject={ActivitySubjects.ActivitySubject.Math}
          categoryTitle={t("Math")}
        />
      </Container>
      <TutoringReviews />
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: `${isMobile ? "7rem" : "10rem"}`
        }}
      >
        <PopularTutors />
        <WhyTutoringOnOutschool ref={whyTutoringRef} />
        {visualLinkGridsCollectionItems?.length && (
          <TutoringForEveryAge
            visualLinkGridsCollectionItem={visualLinkGridsCollectionItems[0]}
          />
        )}
        <TutoringByGrade />
        <TutoringByTopics />
        {!!articles?.length && (
          <TutoringRecommendedArticles articles={articles} />
        )}
      </Container>
    </>
  );
}
export default TutoringPageBody;
